import { Component, OnInit, Input, HostBinding, OnChanges, SimpleChanges } from '@angular/core';
import { AlgGtmService } from '../../../services/alg-gtm.service';

@Component({
  selector: 'alg-accordion',
  templateUrl: './alg-accordion.component.html',
  styleUrls: ['./alg-accordion.component.scss']
})
export class AlgAccordionComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() icon: string;
  @Input() status: string;
  @HostBinding('class.open') isOpen: boolean = false;

    
  constructor(private gtm: AlgGtmService) { }

  ngOnInit() {
    if (this.status === 'active') {
      this.open();
    }
  }


  public open(track=false) {
    if (this.status !== 'disable') {
      if(track) this.gtm.submitOnbEvent('Click su espandi')
      this.isOpen = true;
    }
  }

  public close(track=false) {
    if (this.status !== 'disable') {
      if(track) this.gtm.submitOnbEvent('Click su riduci')
      this.isOpen = false;
    }
  }

  public toggle() {
    this.isOpen ? this.close(true) : this.open(true);
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.status){
      switch(changes.status.currentValue){
        case 'active': this.open(); break;
        case 'completed': this.close(); break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-accordion/alg-accordion.component.ts